import { HrCommonAuthority } from './hr-common-authority';
import { combineAuth } from './hr-authority';

export class ApplicationAuthority extends HrCommonAuthority {

    public static readonly APPLICATION_BASE = "application";

    constructor(authority: string) {
        super(combineAuth(ApplicationAuthority.APPLICATION_BASE, authority));
    }

}
